import type { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { CompInfo, NativeExtensions } from '@wix/thunderbolt-components-native'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import { mapValues } from '../../utils/mapValues'
import type { NodeRefs } from '@wix/thunderbolt-catharsis'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import type { Design } from '../../shared.types'

export const compDesignCssMappers = ({ extensions }: NativeExtensions) => {
	const carmiData = undefined as never
	return createCssCompNode('compCssMappers', 'compDesignCssMappers', {
		getDependencies: (component: Component, refs) => {
			const extension = extensions[component.componentType]
			if (!extension) {
				return null
			}

			const extensionsDeps = mapValues(extension.deps, (__, dep) => {
				if (dep === 'uiType') {
					return refs.uiType(component)
				}
				if (dep === 'compDesign') {
					return refs.compDesigns(component)
				}

				if (!compInfoNodes[dep]) {
					console.warn(`compDesignCssMappers: missing compInfoNode for ${dep}`)
				}

				return compInfoNodes[dep].getDependencies(component, refs as NodeRefs<any>)
			})

			return Object.assign(extensionsDeps, { isMobileView: envRefs.isMobileView })
		},
		toViewItem: (component, deps) => {
			const extension = extensions[component.componentType]
			if (!deps || !extension) {
				return null
			}

			const compInfo = mapValues(extension.deps, (__, dep) => {
				if ('uiType' in deps && dep === 'uiType') {
					return deps[dep]
				}

				return compInfoNodes[dep].toViewItem(component, deps[dep] as never)
			}) as CompInfo
			const compDesign = compInfo.compDesign as Design

			if (!compDesign) {
				throw new Error('Missing `compDesign` dependency in compDesignCss compNode')
			}
			if (compDesign.type === 'classic') {
				return {
					type: compDesign.type,
					css: mapValues(compDesign.css, (design: CompInfo['compDesign']) => {
						return extension.resolver({ ...compInfo, compDesign: design }, deps.additionalData as any)
					}),
				}
			}
			const items = compDesign.css
			return {
				type: compDesign.type,
				css: toBreakpointVariantsMap(items, (item, isDefault) =>
					extension.resolver(
						{
							...compInfo,
							// @ts-ignore - Remove once isDefaultVariant is added to the compInfo
							...(compInfo.isDefaultVariant && { isDefaultVariant: isDefault }),
							compDesign: item,
						},
						carmiData
					)
				),
			}
		},
	})
}
